export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/953bf272c7159fa44f34a644a31a09c9.png";